import { MDXProvider } from "@mdx-js/react";
import type React from "react";
import type { Exception } from "../domain";
import { applyDecoder } from "../lib";
import { baseElements } from "../materials/typography/markdown";
import { E, pipe } from "../prelude";
import { Frontmatter, mkAppLayout } from "./app-layout";
import * as MDXComponents from "./mdx";
import { RenderException } from "./render-exception";

const handleError = (e: Exception) => <RenderException e={e} />;

interface Props {
  children: React.ReactNode;
  frontmatter: Record<string, unknown>;
}

const mdxComponents = {
  ...baseElements,
  ...MDXComponents,
};

export function DefaultMDXProvider(props: Props) {
  const { children, frontmatter } = props;

  const layout = pipe(applyDecoder(Frontmatter, frontmatter), E.fold(handleError, mkAppLayout(children)));

  return <MDXProvider components={mdxComponents}>{layout}</MDXProvider>;
}
